import './style.scss'

export default class levelPopup {
  constructor() {
    this.$root = document.body
  }

  show(data) {
    let template = document.createElement('div')
    template.style.opacity = 0
    template.classList.add('levelPopup')
    // let content = '完成<span>5</span>个回答，至少<span>1</span>个为星标回答，就可以升级<span>1星</span>优质答主，并开通打赏啦~'
    let innerHTML = `
      <div class="levelPopup-wrap">
        <div class="levelPopup-title">
          ${data.name}
        </div>
        <div class="levelPopup-content">
          <div class="levelPopup-honor">
            ${data.title}
          </div>
          <div class="levelPopup-desc">
            ${data.content}
          </div>
          <a href="${data.url}" title="知道了" target="_blank">
            <div class="levelPopup-btn">知道了</div>
          </a>
        </div>
      </div>`
    template.innerHTML = innerHTML
    template.getElementsByClassName('levelPopup-btn')[0].onclick = () => {
      template.style.display = 'none'
    }
    this.$root.appendChild(template)

    this.fadeIn(template)
  }

  fadeIn(elem, speed = 17, opacity = 100) {
    elem.style.display = 'block'
    let val = 0,
      fn = function() {
        elem.style.opacity = val / 100
        val += 5
        if (val <= opacity) {
          setTimeout(fn, speed)
        }
      }
    fn()
  }

  fadeOut(elem, speed = 17, opacity = 0) {
    let val = 100,
      fn = function() {
        elem.style.opacity = val / 100
        val -= 5
        if (val >= opacity) {
          setTimeout(fn, speed)
        } else if (val <= 0) {
          elem.style.display = 'none'
        }
      }
    fn()
  }
}



// WEBPACK FOOTER //
// ./src/public-resource/components/levelPopup/index.js